import {
  IconLayoutDashboard,
  IconCategory,
  IconList,
  IconShoppingCart,
  IconUsers,
  IconRepeat,
} from "@tabler/icons";
import { UserType } from "store/constant";

const icons = {
  IconLayoutDashboard,
  IconCategory,
  IconList,
  IconShoppingCart,
  IconUsers,
  IconRepeat,
};

export const getUtilities = () => {
  const userType = localStorage.getItem("userType");

  const adminMenu = [
    // =====================
    // DASHBOARD
    // =====================
    {
      id: "dashboard",
      title: "Dashboard",
      type: "group",
      children: [
        {
          id: "dashboard-home",
          title: "Dashboard",
          type: "item",
          url: "/dashboard",
          icon: icons.IconLayoutDashboard,
        },
      ],
    },

    // =====================
    // SERVICE CATALOG
    // =====================
    // {
    //   id: "service-catalog",
    //   title: "Service Catalog",
    //   type: "group",
    //   children: [
    //     {
    //       id: "categories",
    //       title: "Categories",
    //       type: "item",
    //       url: "/catalog/categories",
    //       icon: icons.IconCategory,
    //     },
    //     {
    //       id: "services",
    //       title: "Services",
    //       type: "item",
    //       url: "/catalog/services",
    //       icon: icons.IconList,
    //     },
    //   ],
    // },

    // =====================
    // ORDERS
    // =====================
    {
      id: "orders",
      title: "Orders",
      type: "group",
      children: [
        {
          id: "all-orders",
          title: "All Orders",
          type: "item",
          url: "/orders",
          icon: icons.IconShoppingCart,
        },
        {
          id: "orders-by-category",
          title: "Orders by Category",
          type: "collapse",
          icon: icons.IconCategory,
          children: [
            {
              id: "start-business",
              title: "Start Business",
              type: "item",
              url: "/orders/category/start-business",
            },
            {
              id: "compliance",
              title: "Compliance",
              type: "item",
              url: "/orders/category/compliance",
            },
            {
              id: "change-in-business",
              title: "Change in Business",
              type: "item",
              url: "/orders/category/change-in-business",
            },
            {
              id: "registrations",
              title: "Registrations",
              type: "item",
              url: "/orders/category/registrations",
            },
            {
              id: "filing-more",
              title: "Filing & More",
              type: "item",
              url: "/orders/category/filing-more",
            },
            {
              id: "accounting",
              title: "Accounting",
              type: "item",
              url: "/orders/category/accounting",
            },
            {
              id: "drafting",
              title: "Drafting",
              type: "item",
              url: "/orders/category/drafting",
            },
            {
              id: "other-services",
              title: "Other Services",
              type: "item",
              url: "/orders/category/other-services",
            },
          ],
        },
        {
          id: "first-consultations",
          title: "First Consultations",
          type: "item",
          url: "/orders/consult-an-expert",
          icon: icons.IconUsers,
        },
      ],
    },

    // =====================
    // SUBSCRIPTIONS
    // =====================
    // {
    //   id: "subscriptions",
    //   title: "Subscriptions",
    //   type: "group",
    //   children: [
    //     {
    //       id: "active-subscriptions",
    //       title: "Active Subscriptions",
    //       type: "item",
    //       url: "/subscriptions/active",
    //       icon: icons.IconRepeat,
    //     },
    //     {
    //       id: "subscription-orders",
    //       title: "Subscription Orders",
    //       type: "item",
    //       url: "/subscriptions/orders",
    //       icon: icons.IconShoppingCart,
    //     },
    //   ],
    // },
  ];

  // Later expansion
  if (userType === UserType.Admin) return adminMenu;

  return [];
};
